<template> 
    <div class="container-fluid">
        <section class="content-header">
            <div class="row mb-2">
                <h3>{{ $t('general.listadocompanias') }}</h3>
            </div>
        </section>
        <section class="content">
            <div class="row">
                <div class="col-md-2">
                    <div class="card card-widget">
                        <!-- Add the bg color to the header using any of the bg-* classes -->
                        <div class="card-footer p-0">
                            <ul class="nav flex-column">
                                <li class="nav-item active" @click="listado='activas'">
                                    <a href="#" class="nav-link">
                                        {{ $t('general.activas') }} <span class="float-right badge bg-primary">{{total}}</span>
                                    </a>
                                </li>
                                <li v-if="soporte" class="nav-item" @click="listado='eliminadas'">
                                    <a href="#" class="nav-link">
                                        {{ $t('general.eliminadas') }} <span class="float-right badge bg-info">{{companias_eliminadas_num}}</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-md-10">
                    <div v-if="listado=='activas'" class="row" style="margin-bottom: 15px; margin-left: 0">
                        <Dropdown scrollHeight="600px" v-if="sistemas" showClear optionValue="nombre"
                            v-model="sistemaselec" :options="sistemas" @change="obtenerDatos()" filter
                            optionLabel="nombre" placeholder="Sistema">
                        </Dropdown>                        
                    </div>
                    <div v-else>
                        <Dropdown scrollHeight="600px" v-if="sistemas" showClear optionValue="nombre"
                            v-model="sistemaselecelim" :options="sistemas" @change="obtenerDatos()" filter
                            optionLabel="nombre" placeholder="Sistema">
                        </Dropdown>  
                    </div>
                    <div v-if="listado=='activas'">                    
                        <tabla-datos :columnas="columnas" :datos="companias" :filtros="filtros" :filtrosBuscador="filtrosBuscador"
                            @quieroDatos="obtenerDatos($event)" :total="total" :companias="true"></tabla-datos>
                    </div>
                    <div v-else>                    
                        <tabla-datos :columnas="columnas_elim" :datos="companias_eliminadas" :filtros="filtrosElim" :filtrosBuscador="filtrosBuscadorElim"
                            @quieroDatos="obtenerDatos($event)" :total="companias_eliminadas_num"></tabla-datos>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
//import CompanyiasService from '../../../services/CompanyiasService.js'
import { FilterMatchMode } from 'primevue/api';
import { PwgsApi } from '../../../services/PwgsApi';
import TablaDatos from '../../TablaDatos.vue'
export default {
    components: {
        'tabla-datos': TablaDatos,
    },
    data() {
        return {
            mievento:[],
            mieventoelim: [],
            sistemaselecelim:'',
            listado:'activas',
            soporte:false,
            companias_eliminadas_num:0,
            sistemaselec:'',
            sistemas:null,
            companias: [],
            companias_eliminadas:[],
            parametros: null, // query params de DataTable
            filtrosBuscadorElim: ['nombre'],
            filtrosBuscador: ['nombre'], // filtros para el buscador
            filtros: { // filtros de columna
                'nombre': { value: '', matchMode: FilterMatchMode.CONTAINS },
            },
            filtrosElim: { // filtros de columna
                'nombre': { value: '', matchMode: FilterMatchMode.CONTAINS },
            },
            columnas: [
                {
                    header: 'Nombre',
                    field: 'nombre',
                    sortable: true,
                    acciones: [
                        {
                            link: true,
                            tipo: 'default',
                            nombreId: 'idcompañia',
                            // Debe ser arrow function para que this sea este componente
                            accion: (id) => {
                                this.$router.push({
                                    name: 'Compañía',
                                    params: {
                                        id:id
                                    }
                                });
                            }
                        },
                    ]
                },
                {
                    header: 'Prefijo',
                    field: 'prefijo',
                    sortable: true,
                },
                {
                    header: 'Sistema',
                    field: 'sistema_compannia',
                },
                {
                    header: 'CIF',
                    field: 'cif',
                },
                /*{
                    header: 'Domicilio',
                    field: 'domicilio'
                },
                {
                    header: 'CÃ³digo Postal',
                    field: 'cp',
                },
                {
                    header: 'TelÃ©fono',
                    field: 'telefono',
                },
                {
                    header: 'E-Mail',
                    field: 'email',
                },
                {
                    header: 'PoblaciÃ³n',
                    field: 'poblacion',
                },
                {
                    header: 'Provincia',
                    field: 'provincia',
                },*/
                {
                    header: 'Acciones',
                    data: null,
                    acciones: [
                        {
                            nombre: 'Editar',
                            class: 'editar',
                            tipo: 'default',
                            nombreId: 'idcompañia',
                            icono: 'far fa-edit',
                            // Debe ser arrow function para que this sea este componente
                            accion: (id) => {
                                //this.obtenerUsuario(id);
                                this.$router.push({
                                    name: 'Compañía',
                                    params: {
                                        id:id
                                    }
                                });
                            }
                        },                        
                    ]
                }
            ],
            columnas_elim: [
                {
                    header: 'Nombre',
                    field: 'nombre',
                    sortable: true,
                },
                {
                    header: 'Prefijo',
                    field: 'prefijo',
                    sortable: true,
                },
                {
                    header: 'Sistema',
                    field: 'sistema_compannia',
                },
                {
                    header: 'CIF',
                    field: 'cif',
                },
                /*{
                    header: 'Domicilio',
                    field: 'domicilio'
                },
                {
                    header: 'CÃ³digo Postal',
                    field: 'cp',
                },
                {
                    header: 'TelÃ©fono',
                    field: 'telefono',
                },
                {
                    header: 'E-Mail',
                    field: 'email',
                },
                {
                    header: 'PoblaciÃ³n',
                    field: 'poblacion',
                },
                {
                    header: 'Provincia',
                    field: 'provincia',
                },*/
                {
                    header: 'Acciones',
                    data: null,
                    acciones: [
                        {
                            nombre: 'Recuperar',
                            class: 'recuperar',
                            tipo: 'success',
                            nombreId: 'idcompañia',
                            icono: 'fa fa-recycle',
                            // Debe ser arrow function para que this sea este componente
                            accion: (id) => {
                                if (confirm('Desea recuperar la compañía?')) {
                                    this.recuperar(id);
                                }
                            }
                        },                        
                    ]
                }
            ],
        }
    },
    methods: {
        async obtenerSistemas(){
          const api = new PwgsApi();
          var sist = await api.get('sistemas/usados');
          this.sistemas = [];
          this.sistemas = sist.datos;
          this.sistemas.map(sistema => {if(sistema.nombre == 'KLIVAL')  sistema.nombre= 'RNET-EMAIL'});
          this.sistemas.sort((a, b) => a.nombre.localeCompare(b.nombre));
        },        
        async obtenerDatos(parametros) {
            /* get  modulos/pwgsapi/index.php/companias/:id */
            const api = new PwgsApi();
            console.log('parametros', parametros);
            const params = parametros;
            console.log('entraobten');
            if(this.sistemaselec){
                if(this.sistemaselec == 'RNET-EMAIL')
                this.mievento['extra'] = '/sistemas,klival';
                else
                this.mievento['extra'] = '/sistemas,'+[this.sistemaselec];
            }else{
                this.mievento['extra'] = '';
            }
            if(this.sistemaselecelim){
                if(this.sistemaselecelim == 'RNET-EMAIL')
                this.mieventoelim['extra'] = '/sistemas,klival';
                else
                this.mieventoelim['extra'] = '/sistemas,'+[this.sistemaselecelim];
            }else{
                this.mieventoelim['extra'] = '';
            }
            if(this.listado!='eliminadas'){
                if(params){
                    this.mievento['params'] = params;
                }
                const datos = await api.get('companias'+this.mievento['extra'],this.mievento['params']); 
                this.companias = datos.datos;
                this.companias.map(compania => {if(compania.sistema_compannia == 'KLIVAL')  compania.sistema_compannia= 'RNET-EMAIL'});
                this.total = datos.n_total_registros;
            }

            //Total activas/eliminadas
            if(this.listado!='activas'){
                if(params){
                    this.mieventoelim['params'] = params;
                }
                const datos2 = await api.get('companias/0/eliminadas'+this.mieventoelim['extra'],this.mieventoelim['params']);
                this.companias_eliminadas_num = datos2.n_total_registros;
                this.companias_eliminadas = datos2.datos;
                this.companias_eliminadas.map(compania => {if(compania.sistema_compannia == 'KLIVAL')  compania.sistema_compannia= 'RNET-EMAIL'});
            }

            this.columnas[0].header = this.$t("general.nombre");
            this.columnas[1].header = this.$t("general.prefijo");
            this.columnas[2].header = this.$t("general.sistema");
            this.columnas[4].header = this.$t("general.acciones");

            this.columnas_elim[0].header = this.$t("general.nombre");
            this.columnas_elim[1].header = this.$t("general.prefijo");
            this.columnas_elim[2].header = this.$t("general.sistema");
            this.columnas_elim[4].header = this.$t("general.acciones");

            let idusuario = localStorage.getItem('usuario');
            let aux = await api.get('usuarios/' + idusuario + '/permisos');
            let permisos = aux.datos;
            console.log('permisos',permisos);
            this.soporte = false;
            for (let i = 0; i < permisos.length; i++){
                if (permisos[i].nombre_permiso == "soporte") {
                    this.soporte = true;
                }
            }
            console.log('permisos',permisos);
            if (this.soporte == true) {
                console.log('entrafalse');
                this.columnas[4].acciones = [
                    {
                        nombre: 'Editar',
                        class: 'editar',
                        tipo: 'default',
                        nombreId: 'idcompañia',
                        icono: 'far fa-edit',
                        // Debe ser arrow function para que this sea este componente
                        accion: (id) => {
                            //this.obtenerUsuario(id);
                            this.$router.push({
                                name: 'Compañía',
                                params: {
                                    id:id
                                }
                            });
                        }
                    },
                    {
                        nombre: 'Eliminar',
                        class: 'eliminar',
                        tipo: 'danger',
                        nombreId: 'idcompañia',
                        icono: 'far fa-trash-alt',
                        // Debe ser arrow function para que this sea este componente
                        accion: (id) => {
                            if (confirm('Desea eliminar la compañía?')) {
                                this.eliminar(id);
                            }
                        }
                    },
                ]
            }
        },
        async eliminar(id) {
            /* delete  modulos/pwgsapi/index.php/companias/:id */
            const api = new PwgsApi();
            await api.delete('companias/' + id);
            this.obtenerDatos();
        },
        async recuperar(id) {
            const api = new PwgsApi();
            await api.put('companias/' + id + '/recuperar',{estado_companyia:''});
            this.obtenerDatos();
        },
    },
    activated() {
        this.obtenerDatos();
        this.obtenerSistemas();
    }
}
</script>
<style>
.p-dialog {
    width: 90%;
}
</style>